import "../tests/tests.page.css"
import useAnimateIn from "../../hooks/useAnimateIn"
import { useEffect, useState } from "react"
import API from "../../api"
import SkeletonComponent from "../../components/skeleton/skeleton.component"
import moment from "moment"
import { plusIcon } from "../../icons"
import ModalComponent from "../../components/modal/modal.component"
import DropdownComponent from "../../components/dropdown/dropdown.component"
import { ToastContainer, toast } from "react-toastify"

const TrialsPage = (props) => {
  const { user, userMeta } = props
  const [loading, setLoading] = useState(true)
  const [showNewTest, setShowNewTest] = useState()
  const [trials, setTrials] = useState([])
  const [newTest, setNewTest] = useState({
    id: "",
    description: "",
    name: "",
  })

  // Fetch on load
  useEffect(() => {
    const fetchTests = async () => {
      try {
        const trialsRes = await API.makeGetRequest(user, "trials")
        setTrials(trialsRes)
      } catch {
        // todo handle error
      } finally {
        setLoading(false)
      }
    }

    if (user) {
      fetchTests()
    }
  }, [user])

  const getModalContent = () => {
    return (
      <div className="cb-modal-form">
        <p>Please fill in the following fields</p>
        <h6>
          Trial ID<sup>*</sup>
        </h6>
        <input
          type="text"
          value={newTest.id}
          placeholder="Trial ID"
          onChange={(e) => setNewTest({ ...newTest, id: e.target.value })}
        />
        <h6>
          Trial Name<sup>*</sup>
        </h6>
        <input
          type="text"
          value={newTest.name}
          placeholder="Trial Name"
          onChange={(e) => setNewTest({ ...newTest, name: e.target.value })}
        />
        <h6>Description</h6>
        <input
          type="text"
          value={newTest.description}
          placeholder="Description"
          onChange={(e) =>
            setNewTest({ ...newTest, description: e.target.value })
          }
        />
      </div>
    )
  }

  const getModalActions = () => {
    return (
      <>
        <button
          className="cb-primary-btn"
          onClick={handleNewTest}
          disabled={!newTest.id || !newTest.trial || !newTest.name}
        >
          Add
        </button>
        <button className="cb-text-btn" onClick={() => setShowNewTest(false)}>
          Cancel
        </button>
      </>
    )
  }

  const handleNewTest = async () => {
    try {
      setShowNewTest(false)
      setLoading(true)
      const newTestObj = { ...newTest }
      setNewTest({ id: "", description: "", name: "" })
      await API.makePostRequest(user, "trials", newTestObj)
      setTrials([...trials, newTestObj])
      toast.success("Trial created successfully!")
    } catch (e) {
      // Do something here
    } finally {
      setLoading(false)
    }
  }

  useAnimateIn()

  return (
    <div className="cb-page cb-tests">
      <ToastContainer position="top-center" theme="dark" />

      {/* New test */}
      {showNewTest && (
        <ModalComponent
          title="Add New Trial"
          content={getModalContent()}
          onClose={() => setShowNewTest(false)}
          actions={getModalActions()}
        />
      )}

      <div className="cb-page-header">
        <input type="text" placeholder="Search..." />
      </div>
      <div className="cb-page-content">
        <h2>Hello {userMeta.fullName}</h2>
        <h5>Here's all of your clinical trials</h5>

        <div className="cb-list-view">
          <div className="cb-list-view-header">
            <div>
              <h4>Trials</h4>
              <h6>
                Last Updated at{" "}
                {moment().subtract(1, "hour").format("MM/DD/YYYY hh:mm a")}
              </h6>
            </div>
            <button
              className="order-new-btn"
              onClick={() => setShowNewTest(true)}
              disabled={showNewTest}
            >
              {plusIcon} Add New Trial
            </button>
          </div>
          {loading && <SkeletonComponent />}
          <ul className="cb-list">
            <li className="cb-list-row row-header">
              <div>Trial ID</div>
              <div>Trial Name</div>
              <div>Description</div>
            </li>
            {trials?.map((t) => {
              return (
                <li className="cb-list-row" key={t.id}>
                  <div>{t.id}</div>
                  <div>{t.name}</div>
                  <div>{t.description}</div>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default TrialsPage
